import { fetchAuthSession } from "aws-amplify/auth";

const isE2eMockAuth = import.meta.env.VITE_E2E_MOCK_AUTH === "true";
const E2E_MOCK_TOKEN = "e2e-player@chessla.test";

/** Authentication transport belongs to the shared API boundary, not a UI feature. */
export const getAuthToken = async (): Promise<string | null> => {
  if (isE2eMockAuth) return E2E_MOCK_TOKEN;
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
};

export const getCurrentUserEmail = async (): Promise<string | null> => {
  if (isE2eMockAuth) return E2E_MOCK_TOKEN;
  try {
    const session = await fetchAuthSession();
    return (session.tokens?.idToken?.payload.email as string | undefined) ?? null;
  } catch {
    return null;
  }
};
